import { Injectable } from '@angular/core';
import { WindowRefService } from './window-ref.service';
import { DocumentRefService } from './document-ref.service';
// import { environment } from '../../environments/environment';

@Injectable()
export class TealiumUtagService {
  utag_js: string = '';
  utag_sync_js: string = '';
  // Typically set 'noview' flag (no first page automatic view event) to true for Single Page Apps (SPAs)
  constructor(private windowRef: WindowRefService, private documentRef: DocumentRefService) {
    // this.setConfig(TEALIUM_ACCOUNT, TEALIUM_PROFILE, TEALIUM_ENV);
    this.windowRef.nativeWindow.utag_cfg_ovrd = { noview: true };
    this.windowRef.nativeWindow.utag_data = {};
  }

  // Generic script loader with callback
  getScript(src: string, callback: Function) {
    const d = this.documentRef.nativeDocument;
    const o = { callback: callback || function () { } };
    let s, t;

    if (typeof src == 'undefined') {
      return;
    }

    s = d.createElement('script'); s.language = 'javascript'; s.type = 'text/javascript'; s.async = 1; s.charset = 'utf-8'; s.src = src;
    if (typeof o.callback == 'function') {
      if (d.addEventListener) {
        s.addEventListener('load', function () { o.callback(); }, false);
      } else {
        // old IE support
        // tslint:disable-next-line:max-line-length
        s.onreadystatechange = function () { if (this.readyState == 'complete' || this.readyState == 'loaded') { this.onreadystatechange = null; o.callback(); } };
      }
    }
    t = d.getElementsByTagName('script')[0];
    t.parentNode.insertBefore(s, t);
  }

  // Config settings used to build the path to the utag.js file
  setConfig(config: { account: string, profile: string, environment: string }) {
    if (config.account !== undefined && config.profile !== undefined && config.environment !== undefined) {
      this.utag_sync_js = 'https://tags.tiqcdn.com/utag/' + config.account + '/' + config.profile + '/' + config.environment + '/utag.sync.js';
      this.utag_js = 'https://tags.tiqcdn.com/utag/' + config.account + '/' + config.profile + '/' + config.environment + '/utag.js';
    }
  }

  // Data layer is optional set of key/value pairs
  track(tealium_event: string, data?: any) {
    if (this.utag_js === '') {
      return;
    }
    this.windowRef.nativeWindow.utag_data = Object.assign({}, this.windowRef.nativeWindow.utag_data, data);
    if (this.windowRef.nativeWindow.utag === undefined) {
      this.getScript(this.utag_sync_js, () => {
        this.getScript(this.utag_js, () => {
          this.windowRef.nativeWindow.utag.track(tealium_event, data);
        });
      });
    } else {
      this.windowRef.nativeWindow.utag.track(tealium_event, data);
    }
  }

  view(data?: any) {
    this.track('view', data);
  }

  link(data?: any) {
    this.track('link', data);
  }
}
